/*
 * @Author: your name
 * @Date: 2022-04-26 14:21:28
 * @LastEditTime: 2024-12-05 20:05:18
 * @LastEditors: XuJingXin v_xujingxin@tal.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /yach_31_record/packages/auxiliary_ability/src/main.tsx
 */
declare global {
    interface Window {
        yach: any; // 你可以用一个更具体的类型代替any
    }
}
import 'antd/dist/antd.less';
import React from 'react';
import VConsole from 'vconsole'
import 'core-js/stable';
import 'core-js/features/array/at';
import 'regenerator-runtime/runtime';
import ReactDOM from 'react-dom/client';
import App from '@containers/app';
import './index.scss';

import { configure } from 'mobx';
import catchUnhandledRejection from './errorHandler';
import currentEnv from './config'
// import { requestToken } from '@utils/sea'

import setSentry from './utils/sentry';
import { getDeviceTalId } from './utils/config';

configure({ enforceActions: 'observed' });

catchUnhandledRejection();

// const APP_ENV = process.env.VITE_APP_ENV;
const APP_ENV = currentEnv?.VITE_APP_ENV || process.env.VITE_APP_ENV;
console.log('APP_ENV', APP_ENV);
console.log('process.env.VITE_APP_ENV', process.env.VITE_APP_ENV);

if (['test'].includes(APP_ENV)) {
    // eslint-disable-next-line no-new
    new VConsole()
}


const getUA = (): string => {
    return typeof navigator !== 'undefined' ? navigator.userAgent : '';
};

function clientType() {
    const ua = getUA(),
        inSea = /Sea/i.test(ua)
    return inSea
}
if(clientType) setSentry(APP_ENV, getDeviceTalId());

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
